import { Employee } from "./employee";

export class RouteModel {
  id: number;
  idExternal: number;
  name: string;
  thirdPartyCompany: boolean;
  employees: Employee[];
}
